// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M20.5,3.5c-0.5-0.6-1.3-0.9-2.1-0.9c-0.8,0-1.6,0.3-2.2,0.9L4.6,15.2l-1,5.2l5.2-1L20.5,7.8C21.7,6.6,21.7,4.7,20.5,3.5
		C20.5,3.5,20.5,3.5,20.5,3.5z M14.8,6.3l0.7-0.7l2.9,2.9l-0.7,0.7L14.8,6.3z M14.1,7.1l1.1,1l-8.4,8.4l-1.1-1.1L14.1,7.1z
		 M5.7,18.3C5.6,18.1,5.3,18,5.1,18l0.3-1.5l2.1,2.1L6,18.9C6,18.7,5.9,18.4,5.7,18.3z M8.6,18.3l-1.1-1.1l8.4-8.4l1,1.1L8.6,18.3z
		 M19.8,7.1l-0.7,0.7l-2.9-2.9l0.7-0.7c0.4-0.4,0.9-0.6,1.5-0.6c0.5,0,1,0.2,1.4,0.6C20.6,5,20.6,6.3,19.8,7.1z" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-pencil-B9KD83Hb.js.map
